import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { snapSaveState } from "./react-snap";
import { initSentry } from "./lib/sentry";

// Initialize Sentry
initSentry();

// Initialize state for React-Snap when used
try {
  snapSaveState();
} catch (e) {
  console.log('React-snap not available, continuing with normal rendering');
}

const rootElement = document.getElementById("root");

if (!rootElement) {
  throw new Error("Root element not found");
}

// Try-catch to handle both pre-rendered and non-pre-rendered environments
try {
  // Check if the app was prerendered with react-snap
  if (rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, <App />);
  } else {
    createRoot(rootElement).render(<App />);
  }
} catch (e) {
  // Fallback to normal rendering if hydration fails
  console.error('Hydration failed, falling back to normal rendering', e);
  createRoot(rootElement).render(<App />);
}
